<div class="modal-search" [class.input-search-brands-show]="isOpenInputSearch">
  <div class="search-mobile">
    <div
      class="search-mode-dropdown search-mode-dropdown-mobile"
      [class.search-mode-open]="isSearchModeOpen"
    >

      <button
        type="button"
        class="search-mode-button"
        (click)="toggleSearchModeDropdown()"
      >
        <span class="search-mode-label">{{ searchModeLabel }}</span>
        <span class="search-mode-arrow"></span>
      </button>

      <div class="search-mode-backdrop" *ngIf="isSearchModeOpen" (click)="closeSearchModeDropdown()"></div>

      <ul class="search-mode-menu" *ngIf="isSearchModeOpen">
        <li
          [class.active]="urlParams.searchMode === 'default'"
          (click)="selectSearchMode('default')"
        >
          Стандартний
        </li>
        <li
          [class.active]="urlParams.searchMode === 'exact'"
          (click)="selectSearchMode('exact')"
        >
          Точне співпадіння
        </li>
        <li
          [class.active]="urlParams.searchMode === 'ai'"
          (click)="selectSearchMode('ai')"
        >
          AI
        </li>
      </ul>
    </div>
    <div class="search-field-wrapper">
      <input
        type="text"
        class="search-string search-string-mobile"
        [(ngModel)]="urlParams.search"
        (input)="sessionSearchString()"
        (keydown)="searchKeyDown($event)"
        [placeholder]="searchPlaceholder"
      />
      <button
        type="submit"
        *ngIf="urlParams.search === ''"
        class="search-field-button search-field-button-search"
        (click)="searchGood()"
      ></button>
      <button
        type="submit"
        *ngIf="urlParams.search !== ''"
        class="search-field-button search-field-button-cross"
        (click)="crossClears()"
      ></button>
    </div>
  </div>
  <div
    class="search-goods-mobile"
    *ngIf="sessionSearchGoods && sessionSearchGoods.length"
  >
    <a
      *ngFor="let searchGoods of sessionSearchGoods"
      (click)="
        selectGoods(searchGoods.package_id, urlParams.search);
        closeSelectGoods()
      "
    >
      <span class="alert">
        {{ searchGoods.article }}
      </span>
      {{ searchGoods.name }} {{ searchGoods.pack_name }}
      <b *ngIf="searchGoods.inventorization == 1">
        <br />
        (на інвентаризації)
      </b>
    </a>
  </div>
</div>

<div
  class="row expanded items-center top-bar"
  [class.header-hide]="isModalOrdersHistoryNewShow"
>
  <div class="column shrink logo-place">
    <a (click)="goToMainPage()">
      <img src="/assets/images/icons/logo.svg" />
    </a>
  </div>

  <div class="column search-fill">
    <div
      class="search-mode-dropdown search-mode-dropdown-desktop"
      [class.search-mode-open]="isSearchModeOpen"
    >

      <button
        type="button"
        class="search-mode-button"
        (click)="toggleSearchModeDropdown()"
      >
        <span class="search-mode-label">{{ searchModeLabel }}</span>
        <span class="search-mode-arrow"></span>
      </button>

      <div class="search-mode-backdrop" *ngIf="isSearchModeOpen" (click)="closeSearchModeDropdown()"></div>

      <ul class="search-mode-menu" *ngIf="isSearchModeOpen">
        <li
          [class.active]="urlParams.searchMode === 'default'"
          (click)="selectSearchMode('default')"
        >
          Стандартний
        </li>
        <li
          [class.active]="urlParams.searchMode === 'exact'"
          (click)="selectSearchMode('exact')"
        >
          Точне співпадіння
        </li>
        <li
          [class.active]="urlParams.searchMode === 'ai'"
          (click)="selectSearchMode('ai')"
        >
          AI
        </li>
      </ul>
    </div>
    <div class="search-field-wrapper">
      <input
        class="expanded top-search-string top-search-string-desktop"
        type="text"
        [(ngModel)]="urlParams.search"
        (input)="sessionSearchString()"
        (keydown)="searchKeyDown($event)"
        [placeholder]="searchPlaceholder"
        (blur)="hideSearchHelp()"
      />

      <label class="search-icon" *ngIf="urlParams.search === ''">{{
        topSearchString }}</label>
      <label
        class="cross-clears-search-field-desktop"
        *ngIf="urlParams.search !== ''"
        (click)="crossClearsSearchField()"
      ></label>

      <div
        class="search-goods-desktop"
        *ngIf="sessionSearchGoods && sessionSearchGoods.length"
      >
        <a
          *ngFor="let searchGoods of sessionSearchGoods"
          (click)="
            selectGoods(searchGoods.package_id, urlParams.search);
            closeSelectGoods()
          "
        >
          <span class="alert">
            {{ searchGoods.article }}
          </span>
          {{ searchGoods.name }} {{ searchGoods.pack_name }}
          <b *ngIf="searchGoods.inventorization == 1"> (на інвентаризації) </b>
        </a>
      </div>
    </div>

    <label class="label-search-mobile" (click)="openInputSearch()">{{
      topSearchString
    }}</label>
  </div>

  <div class="column shrink rates-row">
    <span class="alert">Курс:</span>
    <span>1 EUR = {{ exchangeRatesEUR }} UAH.</span><br />
    <span class="currencyEur">1 EUR = {{ exchangeRatesUSD }} USD.</span>
  </div>

  <div
    class="column shrink currencies currencies-desktop"
    (click)="onCurrencies()"
    *ngIf="currencies && currencies.id && isOrganizationsLoaded && (!activeOrganization || activeOrganization.type === 'fiz')"
  >
    <a class="currency-name currency-arrow  currency-{{ currencies.id }}">{{
      currencies.name
    }}</a>
    <div
      class="curr-accord-hide"
      [class.curr-accord-show]="isShowListCurrencies"
    >
      <div class="currencies-items" *ngFor="let itemCurrency of getCurrencies">
        <a
          class="currency-name currency-{{ itemCurrency.id }}"
          (click)="setCurrency(itemCurrency.id)"
          >{{ itemCurrency.name }}</a
        >
      </div>
    </div>
  </div>

  <div
    class="column shrink currencies currencies-mobile"
    (click)="modalCurrencies()"
    *ngIf="currencies && currencies.id && isOrganizationsLoaded && (!activeOrganization || activeOrganization.type === 'fiz')"
  >
    <a class="currency-name currency-{{ currencies.id }}">{{
      currencies.name
    }}</a>
  </div>

  <div class="column shrink history history-icon">
    <a (click)="closeModal(); openModalHistory()">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div *ngIf="infoMessageCount > 0" class="info-mess-label-wrapper">
        {{ infoMessageCount }}
      </div>
    </a>
  </div>

  <div class="column shrink receipts">
    <a (click)="closeModal(); openModalReceipts()">
      <img src="/assets/images/delivery-ico.png" />
    </a>
  </div>

  <div class="column shrink my-account" [class.my-account-show]="isShowMenu">
    <a (click)="showAccountMenu()">Меню</a>
  </div>
  <div class="column shrink my-account-mobile">
    <img (click)="showAccountMenu()" src="/assets/images/icons/menuicon.svg" />
  </div>
</div>

<app-modal-history [infoMessageList]="infoMessageList" />

<app-modal-receipts [receiptsList]="receiptsList" />

<app-modal-expected-receipt-goods [waitingGoods]="waitingGoods" />

<app-modal-message
  [infoMessage]="infoMessage"
  (modalInfoMessageConfirm)="modalInfoMessageConfirm()"
/>

<app-modal-delivery [areas]="areas" [delivery]="delivery" />

<app-modal-cards [cards]="cards" (modalPaymentChange)="modalPaymentChange()" />

<app-modal-payment
  [payment]="payment"
  [cards]="cards"
  [getCurrencies]="getCurrencies"
  [ordersForPay]="ordersForPay"
  (modalSendPaymentChange)="modalSendPaymentChange()"
/>

<app-modal-payment-success />

<div
  class="account-menu"
  [class.modals-show]="isAccountMenuShow"
  [class.account-modals-hide]="!isAccountMenuShow"
>
  <a class="close-modal" (click)="closeModal()"></a>
  <div class="nesting">
    <div class="my-account">
      <div *ngIf="user && user.user_id">
        <p>{{ user.fio }}</p>
        <div class="id-user">
          ID: <span>{{ user.user_id }}</span>
        </div>
      </div>
      <div class="sign-out-desktop">
        <a (click)="signOut()">Вихід</a>
      </div>
      <div class="sign-out-mobile">
        <a (click)="signOut()">Вихід</a>
      </div>
    </div>

    <div class="organization-select" *ngIf="activeOrganization && activeOrganization.type !== 'fiz'">
      <span class="organization-title">Організація:</span>
      <span class="organization-name">{{ activeOrganization.name }}</span>
    </div>

    <div class="navigation">
      <ul>
        <li *ngIf="user && user.admin" class="type1 admin">
          <a href="/admin/">Админпанель</a>
        </li>
        <li *ngIf="cards && cards.length > 0" class="type1 requisites">
          <a (click)="openModalRequisites()">Реквізити</a>
        </li>
        <li class="type1 price">
          <a (click)="getPrice()">Завантажити прайс</a>
        </li>
        <li class="type1 price" [class.open]="isPriceMenuOpen">
          <a class="has-sub" (click)="openPriceCategoryMenu($event)"
            >Прайс партнер</a
          >
          <ul class="price-submenu" *ngIf="isPriceMenuOpen">
            <li>
              <a (click)="getPriceCategoryPartner('oils')">Масла</a>
            </li>
            <li>
              <a (click)="getPriceCategoryPartner('filters')">Фільтра</a>
            </li>
            <li>
              <a (click)="getPriceCategoryPartner('parts')">Запчастини</a>
            </li>
          </ul>
        </li>
        <li class="type1 arrivals">
          <a (click)="openModalReceipts()">Нові надходження</a>
        </li>
        <li class="type1 waiting-gds">
          <a (click)="openModalWaitingGoods()">Очікуємо надходження</a>
        </li>
        <li class="type1 favorites">
          <a routerLink="/favorites">Обране</a>
        </li>
        <li class="type1 orders">
          <a routerLink="/orders_history_new" (click)="closeOrders()"
            >Замовлення</a
          >
        </li>
        <li class="type1 delivery">
          <a (click)="openModalDelivery()">Доставка замовлень</a>
        </li>
        <li class="type1 returns">
          <a (click)="openModalReturns()">Зміни та повернення замовлень</a>
        </li>
        <li *ngIf="allowCurlConnect" class="type1 instruction">
          <a (click)="openModalInstructionApi()">API Інструкція</a>
        </li>
        <li class="type1 settings">
          <a routerLink="/personal">Налаштування акаунту</a>
        </li>
        <li class="type1 contacts">
          <a (click)="openModalContacts()">Наші контакти</a>
        </li>
        <li class="type1 about-us">
          <a (click)="openModalAboutUs()">Про нас</a>
        </li>
        <li class="type1 hands">
          <a (click)="openModalProvider()">Постачальникам</a>
        </li>
        <li class="type1 hands">
          <a (click)="openModalWholesaler()">Оптовикам</a>
        </li>
        <li class="type1 hands">
          <a (click)="openModalTermsOfUse()">
            Правова інформація та умови використання сайту
          </a>
        </li>
      </ul>
    </div>
  </div>

  <div class="rights">
    <div class="soc-icons-mobile">
      <span class="logo-made-in-ukraine">
        <img src="assets/images/icons/delicons/logo_made_in_ukraine.jpg" />
      </span>
      <a
        href="https://www.facebook.com/maslotochka.com.ua/videos/733358287410395/?d=n"
        target="_blank"
        rel="nofollow"
      >
        <img
          src="/assets/images/soc-icons/facebook-blue.png"
          alt="facebook icon"
        />
      </a>
      <a
        href="https://instagram.com/maslotochka.com.ua"
        target="_blank"
        rel="nofollow"
      >
        <img
          src="/assets/images/soc-icons/insta-origi.png"
          alt="instagram icon"
        />
      </a>
      <a
        href="https://www.tiktok.com/@maslotochka.com.ua?_t=ZM-90XTwEgDN99&_r=1"
        target="_blank"
        rel="nofollow"
      >
        <img
          class="icon-tiktok"
          src="/assets/images/soc-icons/tiktok.png"
          alt="tiktok"
        />
      </a>
    </div>
    <small>© 2010-{{ currentYear }} Maslotochka. Всі права захищені.</small>
  </div>
</div>

<div
  class="dark-layer"
  [class.modals-show]="isDarkBackground"
  (click)="closeModal()"
></div>

<app-modal-orders-history-new
  [areas]="areas"
  [delivery]="delivery"
  [user]="user"
  [activeOrganization]="activeOrganization"
/>

<app-modal-returns
  (modalReturnsInformationChange)="modalReturnsInformationChange()"
/>

<app-modal-returns-information />

<app-modal-contacts
  [user]="user"
  [contacts_drivers]="contacts_drivers"
  [delivery]="delivery"
  [admins_requisites]="admins_requisites"
/>

<app-modal-currencies
  [exchangeRatesEUR]="exchangeRatesEUR"
  [exchangeRatesUSD]="exchangeRatesUSD"
  [getCurrencies]="getCurrencies"
/>

<app-modal-conditions-information
  (modalOfertaChange)="modalOfertaChange()"
  (modalOfertaCookieChange)="modalOfertaCookieChange()"
  (modalMainPositionChange)="modalMainPositionChange()"
/>

<app-modal-oferta />

<app-modal-oferta-cookie />

<app-modal-mein-position />

<app-modal-about-us />

<app-modal-supplier />

<app-modal-wholesalers />

<app-modal-api-instruction />
